import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Switch"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "switch"
    }}>{`Switch`}</h1>
    <p>{`Form switch input component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Switch } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Switch label="Enable email alerts?" />
`}</code></pre>
    <h2 {...{
      "id": "input-state-style-checked"
    }}>{`Input state style `}<inlineCode parentName="h2">{`&:checked`}</inlineCode></h2>
    <p>{`The Switch component renders several elements, among other things an
`}<inlineCode parentName="p">{`<input type="checkbox" />`}</inlineCode>{`, the state of which can be used to update the style.`}</p>
    <p>{`However, since this input is hidden by CSS (the "visual switch" is a Box),
applying for instance the `}<inlineCode parentName="p">{`&:checked`}</inlineCode>{` CSS selector will not show any difference.`}</p>
    <p>{`To show different style based on the input state, you can use
`}<a parentName="p" {...{
        "href": "https://emotion.sh/docs/styled#nesting-components"
      }}>{`Emotion’s `}<inlineCode parentName="a">{`&`}</inlineCode>{` selector`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Switch
  label="Enable email alerts?"
  sx={{
    bakgroundColor: 'gray',
    // This will not be visible since the input is hidden
    // '&:checked': {
    //   backgroundColor: 'primary'
    // },
    // This will be visible
    'input:checked ~ &': {
      backgroundColor: 'primary',
    },
  }}
/>
`}</code></pre>
    <h2 {...{
      "id": "external-label"
    }}>{`External label`}</h2>
    <p>{`Even though the Switch component already renders a label, but you can also
opt-in for an external label instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Box, Flex, Label, Switch } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex
  sx={{
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 4,
  }}>
  <Label htmlFor="enable-email-alerts" sx={{ flex: 1 }}>
    Enable email alerts?
  </Label>
  <Box>
    <Switch id="enable-email-alerts" />
  </Box>
</Flex>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Switch variants can be defined in `}<inlineCode parentName="p">{`theme.forms`}</inlineCode>{` and the component uses the
`}<inlineCode parentName="p">{`theme.forms.switch`}</inlineCode>{` variant by default.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      